import { mapValues } from "@backmarket/utils/object/mapValues";
import { config } from "./config.js";
export const EXPERIMENTS_HEADER = "bm-experiments";
const defaultExperiments = Object.freeze({
  ...mapValues(config, (experiment) => experiment.defaultValue)
});
export function getExperimentsFromHeaders(headers) {
  const header = headers[EXPERIMENTS_HEADER] ?? "{}";
  try {
    return JSON.parse(header);
  } catch (error) {
    if (error instanceof Error) {
      const message = "Failed to parse %s header";
      console.error(message, EXPERIMENTS_HEADER, { error, value: header });
    }
    return {};
  }
}
export function getDefaultExperiments() {
  return defaultExperiments;
}
